Shopify.Products = (() => {
  const config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: "recently-viewed-products",
    templateId: "recently-viewed-product-template",
    onComplete: null,
  };

  const cookie = {
    configuration: {
      expires: 90,
      path: "/",
      domain: window.location.hostname,
    },
    name: "shopify_recently_viewed",
    write: function (recentlyViewed) {
      const expires = new Date();
      expires.setTime(
        expires.getTime() + this.configuration.expires * 24 * 60 * 60 * 1000,
      );
      document.cookie = [
        `${this.name}=${encodeURIComponent(recentlyViewed.join(" "))}`,
        `expires=${expires.toUTCString()}`,
        `path=${this.configuration.path}`,
        `domain=${this.configuration.domain}`,
      ].join("; ");
    },
    read: function () {
      const prefix = `${this.name}=`;
      const entry = document.cookie
        .split(";")
        .map((value) => value.trim())
        .find((value) => value.startsWith(prefix));
      if (!entry) return [];

      const value = decodeURIComponent(entry.substring(prefix.length));
      return value ? value.split(" ") : [];
    },
    destroy: function () {
      document.cookie = [
        `${this.name}=`,
        "expires=Thu, 01 Jan 1970 00:00:00 GMT",
        `path=${this.configuration.path}`,
        `domain=${this.configuration.domain}`,
      ].join("; ");
    },
    remove: function (productHandle) {
      const recentlyViewed = this.read();
      const position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  const resizeImage = function (src, size) {
    if (size == null) {
      return src;
    }

    if (size == "master") {
      return src.replace(/http(s)?:/, "");
    }

    const match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i,
    );

    if (match != null) {
      const prefix = src.split(match[0]);
      const suffix = match[0];

      return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
    } else {
      return src;
    }
  };

  const formatPrice = (price) => {
    return Intl.NumberFormat("ja-JP", {
      style: "currency",
      currency: "JPY",
    }).format(Math.round(Number(`${price}`.slice(0, -2))));
  };

  const calculateDiscount = (compareAtPrice, price) => {
    if (compareAtPrice > price) {
      const discount = compareAtPrice - price; // 割引額
      const discountPercent = Math.round((discount / compareAtPrice) * 100); // 割引率
      return discountPercent;
    }
  };

  const showSectionTitle = () => {
    document.getElementById("recently-viewed-products-title").innerHTML =
      recentlyViewedHeading;
  };

  // <template> を複製し、data-recently-viewed 属性の付いた要素に商品情報を埋め込む
  const renderProduct = (template, product) => {
    const item = template.content.cloneNode(true);
    const find = (name) =>
      item.querySelector(`[data-recently-viewed="${name}"]`);
    const onSale = product.compare_at_price > product.price;

    const image = find("image");
    if (product.featured_image) {
      image.src = resizeImage(product.featured_image, "medium");
    } else {
      image.remove();
    }

    const link = find("link");
    link.href = product.url;
    link.textContent = product.title;

    const badge = find("badge");
    if (onSale) {
      badge.textContent = `${calculateDiscount(
        product.compare_at_price,
        product.price,
      )}%OFF`;
    } else {
      badge.remove();
    }

    const price = find("price");
    price.textContent = formatPrice(product.price);
    price.className = onSale
      ? "price-item price-item--sale price-item--last sale-price--text"
      : "price-item price-item--regular";

    return item;
  };

  const fetchProduct = async (productHandle) => {
    const root = (window.Shopify.routes && window.Shopify.routes.root) || "/";
    const response = await fetch(
      `${root}products/${encodeURIComponent(productHandle)}.js`,
      { cache: "no-store" },
    );
    if (!response.ok) {
      const error = new Error(`Failed to load product: ${productHandle}`);
      error.status = response.status;
      throw error;
    }
    return response.json();
  };

  return {
    showRecentlyViewed: async function (params) {
      Object.assign(config, params || {});

      const productHandles = cookie.read();
      const template = document.getElementById(config.templateId);
      const wrapper = document.getElementById(config.wrapperId);

      config.howManyToShow = Math.min(
        productHandles.length,
        config.howManyToShow,
      );
      if (!config.howManyToShow || !wrapper || !template) return;

      showSectionTitle();

      // 表示順を保つため、商品を 1 件ずつ取得して描画する
      let shown = 0;
      for (const productHandle of productHandles) {
        if (shown >= config.howManyToShow) break;
        try {
          const product = await fetchProduct(productHandle);
          wrapper.append(renderProduct(template, product));
          shown++;
        } catch (error) {
          // 削除済みの商品は履歴から取り除く
          if (error.status === 404) cookie.remove(productHandle);
        }
      }

      if (config.onComplete) {
        try {
          config.onComplete();
        } catch (error) {}
      }
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {
      Object.assign(config, params || {});

      // 商品ページでのみ記録する
      const match = window.location.pathname.match(/\/products\/([^/]+)/);
      if (!match) return;

      let productHandle;
      try {
        productHandle = decodeURIComponent(match[1]);
      } catch (error) {
        return;
      }

      // 既に履歴にあれば先頭に移動し、無ければ先頭に追加する
      let recentlyViewed = cookie
        .read()
        .filter((handle) => handle !== productHandle);
      recentlyViewed.unshift(productHandle);
      recentlyViewed = recentlyViewed.slice(0, config.howManyToStoreInMemory);

      cookie.write(recentlyViewed);
    },
  };
})();
